import {Pipe, PipeTransform} from '@angular/core';
import {ContactPermission} from '../model/contact-permission.enum';

@Pipe({ name: 'emailUse' })
export class EmailUsePipe implements PipeTransform {

  private pathToLabel = 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.';

  /**
   * @example
   * <div class="value editable">{{emailContactPermission | mobileUse | translate }}</div>
   * @param emailContactPermission
   * @returns {string} The path to the right email use message
   */
  transform(emailContactPermission: ContactPermission): string {
    if (!emailContactPermission) {
      return undefined;
    }
    switch (emailContactPermission) {
      case ContactPermission.ALL: {
        return this.pathToLabel + 'email_all';
      }
      case ContactPermission.P: {
        return this.pathToLabel + 'email_personal';
      }
      case ContactPermission.M: {
        return this.pathToLabel + 'email_my_inbox';
      }
      default: {
        return this.pathToLabel + 'email_none';
      }
    }
  }
}
